import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import React from "react";

function LogOutPage() {
  return (
    <div data-testid="log-out-page">
      <Box sx={{ width: "400px", maxWidth: "95vw", margin: "auto" }}>
        <Card sx={{ margin: "10px 0 10px 0", border: "1px solid", borderColor: "primary.swaBlue" }}>
          <CardContent>
            <Typography sx={{marginBottom: "10px"}}>
              You have been logged out of STARS.
            </Typography>
            <Typography>
            Close all browser windows to ensure your STARS session has ended.
            </Typography>
          </CardContent>
        </Card>
        <Button variant="contained" color="primary" size="large" href="/" sx={{width: "100%"}}>
          <Typography variant="h5" component="h2" sx={{ color: "secondary.main" }}>
            <Box>Log In Again</Box>
          </Typography>
        </Button>
      </Box>
    </div>
  );
}

export default LogOutPage;
